<template>
  <div class="sider_container">
    <slot />
    <TabNav
      :names="activeName"
      :list="tagBarList"
      @change-active="changeActiveName"
    />
    <div class="placeholder" />
    <div class="wrap_menu">
      <Menu
        :active-name="activeName"
        :open-names="[]"
        @on-select="selectMenu"
        style="width: 200px"
      >
        <Submenu v-for="(item, i) in menus" :key="i" :name="i">
          <template slot="title">
            <!-- <Icon :type="item.icon" size="18" /> -->
            {{ item.text }}
          </template>
          <template v-if="item.children.length != 0">
            <MenuItem
              v-for="(sub, j) in item.children"
              :to="sub.attr.url"
              :key="j"
              :name="`${i}-${j}`"
              style="padding-left: 27px"
            >
              <!-- 占位符icon -->
              <Icon type="ios-barcode" size="0" />
              {{ sub.text }}
            </MenuItem>
          </template>
        </Submenu>
      </Menu>
    </div>
  </div>
</template>
<script>
import TabNav from "./TabNav";
import menu from "./menuConfig";
let map = new Map();
/**
 *@TODO 组件由于写的冲忙后期需要二次优化 以及刷新后保存原来相关内容与否 菜单联动封装的太烂了 需要优化
 *@overview 导航栏联动相关
 *@author [damon song]
 *@createDate [2020-06-28]
 */
function formatMap(obj_map) {
  let obj = {};
  [...obj_map.entries()].forEach((value) => {
    obj[value[0]] = value[1];
  });
  return { ...obj };
}
function formatlist(obj_map) {
  let obj = [];
  [...obj_map.entries()].forEach((value) => {
    obj.push(value[0]);
  });
  obj.sort(function (a, b) {
    var onefirst = a.slice(0, 2);
    var foxfirst = b.slice(0, 2);
    let onelast = a.slice(-1);
    let foxlast = b.slice(-1);
    var n = Number(onefirst);
    var s = Number(foxfirst);
    if (isNaN(n)) {
      onefirst = a.slice(0, 1);
    }
    if (isNaN(s)) {
      foxfirst = b.slice(0, 1);
    }
    var aa = onefirst + onelast;
    var bb = foxfirst + foxlast;
    return aa - bb;
  });
  return { ...obj };
}
export default {
  data() {
    return {
      menus: [],
      tagBarList: formatMap(map),
      activeName: "0-0",
      infolist: {},
    };
  },
  inject: ["reload"], //在子组件中注入在父组件中创建的属性
  components: {
    TabNav,
  },
  created() {
    let userInfo = JSON.parse(window.localStorage.getItem("userInfo") || "{}");
    // 如果 companyId 有值，代表是服务商，只显示订单管理
    if (userInfo.companyId) {
      if (userInfo.type == 4) {
        this.menus = menu.serviceMenu2;
      } else {
        this.menus = menu.serviceMenu;
      }
    } else if (userInfo.userId == 10001 || userInfo.userId == 20) {
      this.menus = menu.adminMenu;
    } else {
      this.menus = menu.motionMenu;
    }
  },
  methods: {
    selectMenu(name) {
      let menus = this.menus;
      var first = name.slice(0, 2);
      var n = Number(first);
      if (isNaN(n)) {
        first = name.slice(0, 1);
      }
      let last = name.slice(-1);
      if (menus[first].children.length > 0) {
        map.set(name, {
          path: menus[first].children[last].attr.url,
          subName: menus[first].children[last].text,
          activeName: name,
        });
      } else {
        map.set(name, {
          path: menus[first].attr.url,
          subName: menus[first].text,
          activeName: name,
        });
      }
      this.activeName = name;
      this.tagBarList = formatMap(map);
      console.log(this.tagBarList);
    },
    changeActiveName(key, tag) {
      // 关闭单个标签
      if (tag === "closeSingle") {
        this.infolist = formatlist(map);
        var aa = 0;
        for (var i in this.infolist) {
          let s = this.infolist[i];
          if (key == s) {
            aa = Number(i);
          }
        }
        if (map.size == 1) {
          this.$Message.info("最后一条无法删除");
          return;
        }
        var prokey = "";
        let newTagBarList = this.tagBarList;
        delete newTagBarList[key];
        this.tagBarList = newTagBarList;
        if (this.activeName == key) {
          if (aa == 0) {
            prokey = this.infolist[aa + 1];
          } else {
            prokey = this.infolist[aa - 1];
          }
          if (prokey == this.activeName) {
            prokey = this.infolist[aa - 1];
          } else {
            this.activeName = prokey;
          }
          delete this.infolist[aa];
          map.delete(key);
          this.$router.push(this.tagBarList[prokey].path);
        } else if (this.activeName != key) {
          if (aa == 0) {
            prokey = this.infolist[aa + 1];
          } else {
            prokey = this.infolist[aa - 1];
          }
          delete this.infolist[aa];
          map.delete(key);
          if (prokey == this.activeName) {
            prokey = this.infolist[aa - 1];
            this.reload(); //重新加载页面
          }
          // }else{
          //   this.activeName = prokey;
          // }
          this.activeName = prokey;
          this.$router.push(this.tagBarList[prokey].path);
          // this.$emit("change-active", prokey);
          // this.reload(); //重新加载页面
        }
        return;
      }
      this.activeName = key;
      this.$router.push(this.tagBarList[key].path);
    },
  },
};
</script>
<style lang="less" scoped>
.sider_container {
  position: fixed;
  top: 0;
  left: 0;
  width: 198px;
  height: 100%;
  padding-bottom: 30px;
  overflow: hidden;
  background-color: white;
  box-shadow: 0px 8px 14px 0px rgba(224, 229, 238, 0.5);
  .placeholder {
    height: 54px;
  }
  .wrap_menu {
    width: 210px;
    height: 100%;
    padding-top: 15px;
    padding-bottom: 30px;
    overflow-y: scroll;
  }
}
</style>
